module.exports = __webpack_public_path__ + "07ae7e68d04810235f41644b9d8e9559.svg";